module.exports = __webpack_public_path__ + "img/time-funnel_red.b866c5bf.png";